<!-- <div class="nome_ambiente">{{nomeAmbiente}}</div> -->
<!-- Barra Brasil -->
<div id="barra-brasil" style="background:#7F7F7F; height: 20px; padding:0 0 0 10px;display:block;">
  <ul id="menu-barra-temp" style="list-style:none;">
    <li style="display:inline; float:left;padding-right:10px; margin-right:10px; border-right:1px solid #EDEDED">
      <a href="http://brasil.gov.br" style="font-family:sans,sans-serif; text-decoration:none; color:white;">Portal do
        Governo Brasileiro</a>
    </li>
  </ul>
</div>
<!-- End Barra Brasil -->

<!-- header -->
<!-- End header -->
<header class="br-header" id="header" data-sticky="data-sticky">
  <div class="container-fluid">
    <div class="header-top">
      <div class="header-logo">
        <img (click)="goPrincipal()" src="./../assets/images/circula-govbr-logo_40.png" title="Logomarca CirculaGov" alt="Logomarca CirculaGov">
        <span class="br-divider vertical mx-half mx-sm-1">
        </span>
        <div class="header-sign">Governo Federal</div>
      </div>
      <div class="header-actions">
        <div class="header-links dropdown" [class.show]="showLinksDropdown" id="headerLinksDropdown"
          #headerLinksDropdown>
          <button class="br-button circle small" [class.active]="showLinksDropdown" data-toggle="show"
            data-target="#headerLinksDropdown" type="button" aria-label="Abrir Acesso Rápido"
            (click)="toggleLinksDropdown(); closeFunctionsDropdown()">
            <i class="fas fa-ellipsis-v" aria-hidden="true"></i>
          </button>
          <div class="br-list" (mouseleave)="closeLinksDropdown()">
            <div class="header">
              <div class="title">Acesso Rápido</div>
            </div>
            <!-- <a class="br-item" href="javascript:void(0)" [class.active] = " activeBar === 0" (click)="goPrincipal()">Principal</a> -->
            <a class="br-item" href="javascript:void(0)"
             *ngIf="isLoggedIn && authService.usuario.entidadesPrivadas && authService.usuario.entidadesPrivadas.length > 0"
             (click)="abrirModalAlterarEmpresa();">Alternar perfil de usuário</a>
            <a class="br-item" href="javascript:void(0)" [class.active]=" activeBar === 1"
              (click)="goAnuncios()">Anúncios</a>
            <a class="br-item" href="javascript:void(0)" [class.active]=" activeBar === 6"
              *ngIf="authService.hasRole([PerfilsEnum.GOVERNO,PerfilsEnum.PRIVADO, PerfilsEnum.GESTOR])" (click)="queroDoar()">Quero
              doar</a>
            <!-- <a class="br-item" href="javascript:void(0)" [class.active] = " activeBar === 2" (click)="goFaq()">Perguntas</a> -->
            <!-- <a class="br-item" href="javascript:void(0)" [class.active] = " activeBar === 3" (click)="goFale()">Fale Conosco</a> -->
            <!-- <a class="br-item" href="javascript:void(0)" [class.active] = " activeBar === 4" (click)="goSobre()">Sobre o Sistema</a> -->
          </div>
        </div>
        <span class="br-divider vertical mx-half mx-sm-1"></span>
        <div class="header-functions dropdown" [class.show]="showFunctionsDropdown" id="headerFunctionsDropdown" *ngIf="isLoggedIn"
          #headerFunctionsDropdown>
          <button class="br-button circle small" type="button" data-toggle="show"
            aria-label="Abrir Funcionalidades do Sistema" (click)="toggleFunctionsDropdown(); closeLinksDropdown()">
            <i class="fas fa-th" aria-hidden="true"></i>
          </button>
          <div class="br-list" (mouseleave)="closeFunctionsDropdown()">
            <div class="header">
              <div class="title">Atalhos</div>
            </div>
            <div class="align-items-center br-item">
              <button class="br-button circle small" type="button" aria-label="Mensagens" *ngIf="isLoggedIn"
                (click)="goMensagens()">
                <i class="far fa-envelope" aria-hidden="true"></i>
                <span *ngIf="contadorMensagem > 0" class="badge badge-danger">{{contadorMensagem}}</span>
                <span class="text">Mensagens</span>
              </button>
              <!-- <li class="br-item" *ngIf="authService.hasRole(['GESTOR','GOVERNO', 'CENTRALCOM' ,'PRIVADO'])"
                  (click)="meusDados.hide(); goMensagens();">
                  <i class="fa fa-envelope"></i>
                  Mensagens
                  <span *ngIf="contadorMensagem > 0" class="badge badge-danger contadorNumero">{{contadorMensagem}}</span>
                  <p-progressSpinner *ngIf="loadingContadorMensagem" [style]="{width: '16px', height: '16px'}" strokeWidth="8"
                    style="margin-left: 5px"></p-progressSpinner>
                </li> -->
            </div>
          </div>
        </div>
        <div class="header-search-trigger">
          <button class="br-button circle" type="button" aria-label="Abrir Busca" data-toggle="search"
            data-target=".header-search"
            (click)="openSearch(); closeLinksDropdown(); closeNotification(); closeFunctionsDropdown();">
            <i class="fas fa-search" aria-hidden="true"></i>
          </button>
        </div>
        <div class="header-login">
          <div class="header-sign-in" *ngIf="!isLoggedIn" class="col" [class.active]=" activeBar === 5">
            <button class="br-button sign-in small" type="button" data-trigger="login" (click)="goLogin()">
              <i class="fas fa-user" aria-hidden="true"></i>
              <span class="d-sm-inline">Entrar</span>
            </button>
          </div>
          <div class="header-avatar" *ngIf="isLoggedIn">
            <div class="avatar dropdown" [class.show]="showNotification">
              <span class="br-avatar" title="{{usuarioLogado.nomeAbreviado}} - {{entidadeUsuarioLogadoCompleto()}}" id="avatarUsuarioLogado">
                <span class="image">
                  <span *ngIf="hasNotification" class="badge badge-danger">{{totalNotificacoes}}</span>
                  <img  *ngIf="imagemUrl != null" [src]="imagemUrl"  alt="Avatar">
                  <i *ngIf="imagemUrl == null"  class="fas fa-user" aria-hidden="true"></i>
                  <!--<i *ngIf="hasNotification" class="fas fa-circle notification"></i>-->
                </span>
                <small *ngIf="isLoggedIn">{{entidadeUsuarioLogado()}}</small>
              </span>
              <button class="br-button circle small" type="button" aria-label="Abrir Menu de usuário"
                id="btnUsuarioLogado" [class.active]="showNotification" #btnUsuarioLogado
                (click)="meusDados.toggle($event); toggleNotification(); closeFunctionsDropdown(); closeLinksDropdown();">
                <i class="fas fa-angle-down" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="header-bottom">
      <div class="header-menu">
        <div class="header-menu-trigger">
          <button class="br-button small circle" type="button" aria-label="Menu" data-toggle="menu"
            data-target="#main-navigation" id="navigation" (click)="toggleMenu()">
            <i class="fas fa-bars" aria-hidden="true"></i>
          </button>
        </div>
        <div class="header-info">
          <div class="header-title">CirculaGov - Sistema de Circularidade de bens móveis do Governo Federal.</div>
          <!-- <div class="header-subtitle">Subtítulo do Header</div> -->
        </div>
      </div>
      <div class="header-search" [class.active]="showSearch">
        <div class="br-input has-icon">
          <label for="searchbox-92134">Texto da pesquisa</label>
          <input pInputText ngModel name="pesquisa" type="text" (keyup.enter)="pesquisar()"
            placeholder="O que você procura?" aria-label="O que você procura?" maxlength="200" [(ngModel)]="pesquisa">
          <button class="br-button circle small" type="button" aria-label="Pesquisar" (click)="pesquisar()">
            <i class="fas fa-search" aria-hidden="true"></i>
          </button>
        </div>
        <button class="br-button circle search-close ml-1" type="button" aria-label="Fechar Busca" data-dismiss="search"
          (click)="closeSearch()">
          <i class="fas fa-times" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </div>
</header>


<!-- navbar -->
<!-- <nav class="navbar-menu navbar navbar-expand-lg navbar-dark">

    <div class="container">
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup"
        aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse justify-content-between" id="navbarNavAltMarkup">
        <div class="navbar-nav">
          <div class="nav-item nav-link px-0" [ngClass]="{'active': activeBar === 0}" (click)="goPrincipal()">Principal
          </div>
          <div class="nav-item nav-link px-0" [ngClass]="{'active': activeBar === 1}" (click)="goAnuncios()">Anúncios
          </div>
          <div class="nav-item nav-link px-0" [ngClass]="{'active': activeBar === 2}" (click)="goFaq()">Perguntas
            Frequentes</div>
          <div class="nav-item nav-link px-0" [ngClass]="{'active': activeBar === 3}" (click)="goFale()">Fale Conosco
          </div>
          <div class="nav-item nav-link px-0" [ngClass]="{'active': activeBar === 4}" (click)="goSobre()">Sobre o
            Sistema</div>
        </div>
        <button type="button" class="btn donate" (click)="queroDoar()"
          [ngClass]="{'activeQueroDoar': activeBar === 6}">Quero doar</button>
      </div>
    </div>

  </nav> -->
<!-- End navbar -->
<div class="br-menu" [class.active]="showMenu" id="main-navigation">
  <div class="menu-container">
    <div class="menu-panel col-sm-4 col-lg-3">
      <div class="menu-header">
        <div class="menu-title">
          <img src="./../assets/images/circula-govbr-logo_40.png" title="Logomarca CirculaGov" alt="Logomarca CirculaGov">
          <!-- <span>Identificação do site ou Sistema</span> -->
        </div>
        <div class="menu-close">
          <button class="br-button circle" type="button" aria-label="Fechar o menu" data-dismiss="menu"><i
              class="fas fa-times" aria-hidden="true" (click)="closeMenu()"></i>
          </button>
        </div>
      </div>
      <nav class="menu-body">
        <div class="menu-folder drop-menu">
          <a class="menu-item" href="javascript: void(0)" [class.active]="activeBar === 0"
            (click)="goPrincipal(); closeMenu()">
            <span class="icon">
              <i class="fas fa-home" aria-hidden="true"></i>
            </span>
            <span class="content">Principal</span>
            <span class="support">
              <!-- <i class="fas fa-angle-down" aria-hidden="true"></i> -->
            </span>
          </a>
        </div>
        <div class="menu-folder drop-menu">
          <a class="menu-item" href="javascript: void(0)"
            *ngIf="isLoggedIn && authService.usuario.entidadesPrivadas && authService.usuario.entidadesPrivadas.length > 0" (click)="closeMenu(); abrirModalAlterarEmpresa();">
            <span class="icon">
              <i class="fas fa-exchange-alt" aria-hidden="true"></i>
            </span>
            <span class="content">Alternar perfil de usuário</span>
            <span class="support">
              <!-- <i class="fas fa-angle-down" aria-hidden="true"></i> -->
            </span>
          </a>
        </div>
        <div class="menu-folder drop-menu">
          <a class="menu-item" href="javascript: void(0)" [class.active]="activeBar === 1"
            (click)="goAnuncios(); closeMenu()">
            <span class="icon">
              <i class="fas fa-search" aria-hidden="true"></i>
            </span>
            <span class="content">Anúncios</span>
            <span class="support">
              <!-- <i class="fas fa-angle-down" aria-hidden="true"></i> -->
            </span>
          </a>
        </div>
        <div class="menu-folder drop-menu">
          <a class="menu-item" href="javascript: void(0)" [class.active]="activeBar === 6"
            (click)="queroDoar(); closeMenu()">
            <span class="icon">
              <i class="fas fa-handshake" aria-hidden="true"></i>
            </span>
            <span class="content">Quero doar</span>
            <span class="support">
              <!-- <i class="fas fa-angle-down" aria-hidden="true"></i> -->
            </span>
          </a>
        </div>
        <div class="menu-folder drop-menu">
          <a class="menu-item" href="javascript: void(0)" [class.active]="activeBar === 2"
            (click)="goFaq(); closeMenu()">
            <span class="icon">
              <i class="fas fa-question" aria-hidden="true"></i>
            </span>
            <span class="content">Perguntas</span>
            <span class="support">
              <!-- <i class="fas fa-angle-down" aria-hidden="true"></i> -->
            </span>
          </a>
        </div>
        <div class="menu-folder drop-menu">
          <a class="menu-item" href="javascript: void(0)" [class.active]="activeBar === 3"
            (click)="goFale(); closeMenu()">
            <span class="icon">
              <i class="fas fa-phone" aria-hidden="true"></i>
            </span>
            <span class="content">Fale Conosco</span>
            <span class="support">
              <!-- <i class="fas fa-angle-down" aria-hidden="true"></i> -->
            </span>
          </a>
        </div>
        <div class="menu-folder drop-menu">
          <a class="menu-item" href="javascript: void(0)" [class.active]="activeBar === 4"
            (click)="goSobre(); closeMenu()">
            <span class="icon">
              <i class="fas fa-info" aria-hidden="true"></i>
            </span>
            <span class="content">Sobre o Sistema</span>
            <span class="support">
              <!-- <i class="fas fa-angle-down" aria-hidden="true"></i> -->
            </span>
          </a>
        </div>
      </nav>
      <!-- <div class="menu-footer">
          <div class="menu-logos"><img src="data:image/png;base64,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" alt="Imagem ilustrativa"><img src="data:image/png;base64,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" alt="Imagem ilustrativa"></div>
          <div class="menu-links"><a href="javascript: void(0)"><span class="mr-1">Link externo 1</span><i class="fas fa-external-link-square-alt" aria-hidden="true"></i></a><a href="javascript: void(0)"><span class="mr-1">Link externo 2</span><i class="fas fa-external-link-square-alt" aria-hidden="true"></i></a></div>
          <div class="menu-social">
            <div class="text-semi-bold mb-1">Redes Sociais</div>
            <div class="sharegroup">
              <div class="share"><a class="br-button circle" href="javascript: void(0)" aria-label="Compartilhar por Facebook"><i class="fab fa-facebook-f" aria-hidden="true"></i></a></div>
              <div class="share"><a class="br-button circle" href="javascript: void(0)" aria-label="Compartilhar por Twitter"><i class="fab fa-twitter" aria-hidden="true"></i></a></div>
              <div class="share"><a class="br-button circle" href="javascript: void(0)" aria-label="Compartilhar por Linkedin"><i class="fab fa-linkedin-in" aria-hidden="true"></i></a></div>
              <div class="share"><a class="br-button circle" href="javascript: void(0)" aria-label="Compartilhar por Whatsapp"><i class="fab fa-whatsapp" aria-hidden="true"></i></a></div>
            </div>
          </div>
          <div class="menu-info">
            <div class="text-center text-down-01">Todo o conteúdo deste site está publicado sob a licença <strong>Creative Commons Atribuição-SemDerivações 3.0</strong></div>
          </div>
        </div> -->
    </div>
    <div class="menu-scrim" data-dismiss="menu" tabindex="0" (click)="closeMenu()"></div>
  </div>
</div>


<p-overlayPanel #meusDados class="br-notification" [class.show]="showNotification"
  (mouseleave)="meusDados.hide(); closeNotification();">

  <div class="notification-header">
    <div class="row">
      <div class="col-10" *ngIf="isLoggedIn" title="{{usuarioLogado.nomeAbreviado}} - {{entidadeUsuarioLogadoCompleto()}}">
        <span class="text-bold">{{usuarioLogado.nomeAbreviado}}</span><br>
        <small>{{entidadeUsuarioLogado()}}</small>
      </div>
    </div>
  </div>
  <div class="notification-body">
    <ul id="meusDadosUl" class="br-list">
      <li class="br-item" *ngIf="authService.hasRole([PerfilsEnum.GESTOR,PerfilsEnum.GOVERNO])"
        (click)="meusDados.hide(); goUrl(MEUS_ANUNCIOS_GOVERNO);">
        <i class="fa fa-newspaper"></i>
        Anúncios da unidade
      </li>
      <li class="br-item" *ngIf="authService.hasRole([PerfilsEnum.PRIVADO])"
        (click)="meusDados.hide(); goUrl(MEUS_ANUNCIOS_PRIVADO);">
        <i class="fa fa-newspaper"></i>
        Meus Anúncios
      </li>

      <li class="br-item" *ngIf="authService.hasRole([PerfilsEnum.PRIVADO])"
        (click)="meusDados.hide(); goUrl(REPUBLICAR_ANUNCIOS_PRIVADO);">
        <i class="fa fa-refresh"></i>
        Republicar Anúncio
      </li>

      <li class="br-item" *ngIf="authService.hasRole([PerfilsEnum.GESTOR,PerfilsEnum.GOVERNO, PerfilsEnum.GOVERNO_ESTADUAL_MUNICIPAL, PerfilsEnum.PRIVADO_COM_INTERESSE])"
        (click)="meusDados.hide(); goUrl(MEUS_INTERESSES);">
        <i class="fa fa-heart"></i>
        Interesses da unidade
      </li>

      <li class="br-item" *ngIf="authService.hasRole([PerfilsEnum.CENTRALCOM,PerfilsEnum.GOVERNO,PerfilsEnum.SEGES])"
        (click)="meusDados.hide();goUrl(AUTORIZAR_PUBLICACAO);">
        <i class="fa fa-globe"></i>
        Autorizar Publicação
        <span *ngIf="contadorAutorizarPublicacao > 0"
          class="badge badge-danger contadorNumero">{{contadorAutorizarPublicacao}}</span>
        <p-progressSpinner *ngIf="loadingContadorAutorizarPublicacao" [style]="{width: '16px', height: '16px'}"
          strokeWidth="8" style="margin-left: 5px"></p-progressSpinner>
      </li>

      <li class="br-item" *ngIf="authService.hasRole([PerfilsEnum.GESTOR,PerfilsEnum.GOVERNO,PerfilsEnum.SEGES,PerfilsEnum.PRIVADO])"
        (click)="meusDados.hide(); goUrl(MEUS_ANUNCIOS_INTERESSES);">
        <i class="fa fa-gavel"></i>
        Autorizar Doação
        <span *ngIf="contadorAutorizarDoacao > 0"
          class="badge badge-danger contadorNumero">{{contadorAutorizarDoacao}}</span>
        <p-progressSpinner *ngIf="loadingContadorAutorizarDoacao" [style]="{width: '16px', height: '16px'}"
          strokeWidth="8" style="margin-left: 5px"></p-progressSpinner>
      </li>

      <li class="br-item" *ngIf="authService.hasRole([PerfilsEnum.GOVERNO, PerfilsEnum.GOVERNO_ESTADUAL_MUNICIPAL, PerfilsEnum.PRIVADO_COM_INTERESSE])" (click)="meusDados.hide(); goUrl(CONFIRMAR_DOACAO);">
        <i class="fa fa-handshake"></i>
        Confirmar Doação
        <span *ngIf="contadorConfirmarDoacao > 0"
          class="badge badge-danger contadorNumero">{{contadorConfirmarDoacao}}</span>
        <p-progressSpinner *ngIf="loadingContadorConfirmarDoacao" [style]="{width: '16px', height: '16px'}"
          strokeWidth="8" style="margin-left: 5px"></p-progressSpinner>
      </li>

      <li class="br-item" *ngIf="authService.hasRole([PerfilsEnum.GESTOR,PerfilsEnum.GOVERNO])"
        (click)="meusDados.hide(); goUrl('desbloqueio-anuncio');">
        <i class="fa fa-unlock"></i>
        Desbloquear Anúncios
      </li>
      <li class="br-item" *ngIf="authService.hasRole([PerfilsEnum.CENTRALCOM,PerfilsEnum.SEGES])"
        (click)="meusDados.hide(); goUrl('bloqueio-usuario-privado');">
        <i class="fa fa-lock"></i>
        Bloquear Usuários Privados
      </li>
      <li class="br-item" *ngIf="authService.hasRole([PerfilsEnum.GESTOR])"
        (click)="meusDados.hide();goUrl(LISTAR_CADASTRO_USUARIO_GOVERNO);">
        <i class="fa fa-vcard"></i>
        Cadastrar Usuários de Governo
      </li>
      <li class="br-item" *ngIf="authService.hasRole([PerfilsEnum.GESTOR])"
        (click)="meusDados.hide();goUrl(LISTAR_CADASTRO_ENTIDADE);">
        <i class="fa fa-building"></i>
        Cadastrar Entidades
      </li>
      <li class="br-item" *ngIf="authService.hasRole([PerfilsEnum.CENTRALCOM,PerfilsEnum.SEGES])"
        (click)="meusDados.hide();goUrl(CONSULTAR_ANUNCIO_PRIVADO);">
        <i class="fa fa-users"></i>
        Consultar Anúncios Privados
      </li>
      <li class="br-item" *ngIf="authService.hasRole([PerfilsEnum.SEGES, PerfilsEnum.GESTOR, PerfilsEnum.GOVERNO, PerfilsEnum.CENTRALCOM])"
        (click)="meusDados.hide(); goUrl(RELATORIO_ANUNCIO);">
        <i class="fa fa-pie-chart"></i>
        Relatório de Anúncios
      </li>
      <!--
        <li class="br-item" *ngIf="authService.hasRole(['CENTRALCOM'])" (click)="meusDados.hide();">
          <i class="fa fa-minus-circle"></i>
          Bloquear Usuários Privados
        </li>
        -->
      <li class="br-item"  (click)="meusDados.hide(); goMensagens();">
        <i class="fa fa-envelope"></i>
        Mensagens
        <span *ngIf="contadorMensagem > 0" class="badge badge-danger contadorNumero">{{contadorMensagem}}</span>
        <p-progressSpinner *ngIf="loadingContadorMensagem" [style]="{width: '16px', height: '16px'}" strokeWidth="8"
          style="margin-left: 5px"></p-progressSpinner>
      </li>
      <!--
        <li class="br-item" (click)="meusDados.hide();">
        <i class="fa fa-wrench"></i>
          Configurações
        </li>
        -->
      <li class="br-item" (click)="meusDados.hide(); logout();">
        <i class="fa fa-reply"></i>
        Sair
      </li>
    </ul>
  </div>

</p-overlayPanel>
<div >
  <alterar-empresa #alterarEmpresa  ></alterar-empresa>
</div>




